/// <reference path="./global.d.ts" />

/**
 * Scroll Fade-In Animation with GSAP ScrollTrigger
 *
 * This script adds fade-in animations to entire sections as they come into view.
 * It targets all elements with the class "shopify-section".
 */

class ScrollFadeIn {
  constructor() {
    this.sections = document.querySelectorAll(
      ".shopify-section:not(footer):not(header):not(.hero-wrapper):not(.content-for-layout > .shopify-section:first-child)",
    );
    this.init();
  }

  init() {
    // Wait for GSAP and ScrollTrigger to be available
    if (typeof gsap === "undefined") {
      console.warn("Scroll Fade-In: GSAP not loaded");
      return;
    }

    if (typeof ScrollTrigger === "undefined") {
      console.warn("Scroll Fade-In: ScrollTrigger plugin not loaded");
      return;
    }

    // Register the ScrollTrigger plugin
    gsap.registerPlugin(ScrollTrigger);

    // Set initial state for headings (opacity 0)
    this.setInitialState();

    // Create animations for each section
    this.createAnimations();
  }

  setInitialState() {
    // Set all sections to opacity 0 initially
    this.sections.forEach((section) => {
      gsap.set(section, { opacity: 0 });
    });
  }

  createAnimations() {
    this.sections.forEach((section, i) => {
      gsap.to(section, {
        opacity: 1,
        duration: 1.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: section,
          start: "top 80%", // Section fades in when its top is 20vh into the viewport
          end: "+=300",
          toggleActions: "play none none reverse",
          // Optional: Add markers for debugging (remove in production)
          // markers: true
        },
      });
    });
  }

  // Method to refresh ScrollTrigger (useful for dynamic content)
  refresh() {
    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.refresh();
    }
  }

  // Method to kill all ScrollTrigger instances (useful for cleanup)
  kill() {
    if (typeof ScrollTrigger !== "undefined") {
      ScrollTrigger.killAll();
    }
  }
}

// Initialize when DOM is ready
document.addEventListener("DOMContentLoaded", () => {
  // Wait a bit for GSAP to load
  setTimeout(() => {
    new ScrollFadeIn();
  }, 100);
});

// Export for manual use
window.ScrollFadeIn = ScrollFadeIn;
